import React from 'react';
import { Button, ButtonAsButtonProps } from '../../../buttons';

export type ModalActionButtonProps = ButtonAsButtonProps;

export const ModalActionButton: React.FC<ModalActionButtonProps> = ({
  ...rest
}) => {
  return (
    <Button
      className="w-full sm:w-auto"
      layout="squared"
      variant="blue"
      font="boldPrimary"
      {...rest}
    />
  );
};
